import { RoomScreen } from "../../features/room";

/** FS-ROOM 우리 반 룸 — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/room */
export default function RoomPage() {
  return <RoomScreen />;
}
